import { render, staticRenderFns } from "./organization-invite.modal.vue?vue&type=template&id=7d6b2b96&"
import script from "./organization-invite.modal.vue?vue&type=script&lang=ts&"
export * from "./organization-invite.modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports